module.exports = "/reports/components/reportsChartsComponent-687d8a.html";